const sortAndFilterOrgs = (orgs = [], searchVal = '', bool = true) => {
  return bool
    ? [...orgs].filter(el => el.name?.toLowerCase().includes(searchVal.toLowerCase()))
    : [...orgs].sort((a, b) => a.score - b.score).filter(el => el.name?.toLowerCase().includes(searchVal.toLowerCase()))
}

export {sortAndFilterOrgs}